import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { GroupedCaseStudy } from '@layouts/CaseStudies/types';

import * as styles from './Header.module.scss';

export const Header: React.FC<GroupedCaseStudy['general']> = ({
	branch,
	category,
	projectLength,
	projectMembers,
	description,
	title,
	technologies,
	tools,
}) => {
	return (
		<PaddingContainer className={classNames('white-bg', styles.root)}>
			<WidthContainer>
				<div>
					<h1 className="font-size-large m-0">{title}</h1>
					<p className="font-size-sm mt-2 limit-text">{description}</p>
				</div>
				<div className="font-size-sm mt-4">
					<p className="font-600">Technologies used</p>
					<p>{technologies}</p>
					<p className="mt-3 font-600">Tools</p>
					<p>{tools}</p>
				</div>
				<div className={classNames(styles.cards, 'mt-3 d-flex flex-wrap')}>
					<div>
						<p className="font-size-md font-600">{projectMembers}</p>
						<p>Project members</p>
					</div>
					<div>
						<p className="font-size-md font-600">{projectLength}</p>
						<p>Project length</p>
					</div>
					<div>
						<p className="font-size-md font-600">{category}</p>
						<p>Category</p>
					</div>
					<div>
						<p className="font-size-md font-600">{branch}</p>
						<p>Branch</p>
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
